module.exports = __webpack_public_path__ + "static/img/bc-ppglw.4d9cc2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-ppglw.png
// module id = wxaf
// module chunks = 0